import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8002";
export const baseURL = "https://parts-backend.palmaseguros.tech";

// export const baseURL = "https://testparts-backend.palmaseguros.tech";

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
